import React, { useCallback, useState } from "react";
import { FileText, X } from "lucide-react";
import SelectMsbDropdown from "./SelectMsbDropdown";
import { usePopupLifecycle } from "../../view/popup/usePopupLifecycle";

function CopyMoveToMsbPopup({ closePopup, confirm, title }) {

    const [msbId, setMsbId] = useState(-1);

    const handleClose = useCallback(() => closePopup(), [closePopup]);
    usePopupLifecycle(handleClose);

    const onSaveClick = () => {
        closePopup();
        confirm(msbId);
    };

    return (
        <div className="oct-shared-popup" role="dialog" aria-modal="true" aria-labelledby="oct-copy-move-msb-title">
            <div className="oct-shared-popup__backdrop" onClick={handleClose} />

            <div className="oct-shared-popup__dialog oct-shared-popup__dialog--compact" onClick={(event) => event.stopPropagation()}>
                <div className="oct-shared-popup__header">
                    <div className="oct-shared-popup__title-wrap">
                        <div className="oct-shared-popup__title-icon">
                            <FileText size={18} />
                        </div>
                        <div>
                            <h4 id="oct-copy-move-msb-title" className="oct-shared-popup__title">{title}</h4>
                            <p className="oct-shared-popup__subtitle">Choose the destination MSB for the selected rule set.</p>
                        </div>
                    </div>

                    <button type="button" className="oct-shared-popup__close" onClick={handleClose} aria-label={`Close ${title} popup`}>
                        <X size={18} />
                    </button>
                </div>

                <div className="oct-shared-popup__body oct-shared-popup__body--form">
                    <SelectMsbDropdown setMsbId={setMsbId} msbId={msbId} />
                </div>

                <div className="oct-shared-popup__footer oct-shared-popup__footer--end">
                    <button type="button" className="btn oct-shared-popup__btn oct-shared-popup__btn--secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn oct-shared-popup__btn oct-shared-popup__btn--primary"
                        disabled={Number(msbId) === -1}
                        onClick={onSaveClick}
                    >
                        Save
                    </button>
                </div>
            </div>
        </div>
    )

}

export default CopyMoveToMsbPopup;
